import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"
import { initInvestmentCalculatorPage } from "./lib/investment_calculator"
import { initContributionPlannerPage } from "./lib/contribution_planner"
import { initXeqtPriceTicker } from "./lib/xeqt_price"

console.info("Bridgetown is loaded!", components)

document.addEventListener("DOMContentLoaded", () => {
  initInvestmentCalculatorPage()
  initContributionPlannerPage()
  initXeqtPriceTicker()

  // Wrap tables in a scrollable container for mobile
  document.querySelectorAll("main table").forEach((table) => {
    if (!table.parentElement.classList.contains("table-wrap")) {
      const wrapper = document.createElement("div")
      wrapper.className = "table-wrap"
      table.parentNode.insertBefore(wrapper, table)
      wrapper.appendChild(table)
    }
  })
})
